const partConfiguration: any = {
    项目名称: "宜心健康客户管理平台（管理端）",
    name: "fqxk",// 项目名称，用来项目部分功能的区分。
    agreePage: 'fqxk',// 知情同意书
    qrPage: [// 来源管理能跳转的二维码页面
        {
            label: '新增患者',
            value: '新增患者'
        },
        {
            label: '心脏无忧测评',
            value: '心脏无忧测评'
        },
        {
            label: '绑定健康卡-输入卡密',
            value: '绑定健康卡-输入卡密'
        }
    ],
    leftNav: [
        {
            name: '医生管理',
            icon: '&#xe6dc;',
            activePath: '/main/doctor',
            open: false,
            children: [
                {
                    parent: '医生管理',
                    name: '医生账户',
                    path: '/main/doctor/account',
                    activePath: '/main/doctor/account'
                },
                {
                    parent: '医生管理',
                    name: '角色管理',
                    path: '/main/doctor/role',
                    activePath: '/main/doctor/role'
                },
                {
                    parent: '医生管理',
                    name: '医院管理',
                    path: '/main/doctor/hospital',
                    activePath: '/main/doctor/hospital'
                },
            ]
        },
        {
            name: '内容管理',
            icon: '&#xe6da;',
            open: false,
            activePath: '/main/content',
            children: [
                {
                    parent: '内容管理',
                    name: '营养库',
                    path: '/main/content/yingyangku',
                    activePath: '/main/content/yingyangku'
                },
                {
                    parent: '内容管理',
                    name: '运动库',
                    path: '/main/content/yundongku',
                    activePath: '/main/content/yundongku'
                },
                {
                    parent: '内容管理',
                    name: '指标库',
                    path: '/main/content/zhibiaoku',
                    activePath: '/main/content/zhibiaoku'
                },
                {
                    parent: '内容管理',
                    name: '干预库',
                    path: '/main/content/ganyuku',
                    activePath: '/main/content/ganyuku'
                },
                {
                    parent: '内容管理',
                    name: '西药库',
                    path: '/main/content/xiyaoku',
                    activePath: '/main/content/xiyaoku'
                },
                {
                    parent: '内容管理',
                    name: '检验库',
                    path: '/main/content/jianyanku',
                    activePath: '/main/content/jianyanku'
                },
                {
                    parent: '内容管理',
                    name: '检查库',
                    path: '/main/content/jianchaku',
                    activePath: '/main/content/jianchaku'
                },
                {
                    parent: '内容管理',
                    name: '科普库',
                    path: '/main/content/kepuku',
                    activePath: '/main/content/kepuku'
                },
            ]
        },
        {
            name: '测评管理',
            icon: '&#xe6d8;',
            path: '/main/ceping/folder',
            activePath: '/main/ceping'
        },
        {
            name: '随访管理',
            icon: '',
            path: '/main/followup/folder',
            activePath: '/main/followup'
        },
        {
            name: '客户管理',
            icon: '&#xe6d8;',
            path: '/main/patient/dangan',
            activePath: '/main/patient/dangan'
        },
        // {
        //     name: '数据统计',
        //     icon: '&#xe6e0;',
        //     activePath: '/main/statistics',
        //     open: false,
        //     children: [
        //         // {
        //         //     parent: '数据统计',
        //         //     name: '大屏看板',
        //         //     path: '/main/statistics/show',
        //         //     activePath: '/main/statistics/show'
        //         // },
        //     ]
        // },
        {
            name: '系统设置',
            icon: '&#xe6dd;',
            activePath: '/main/setting',
            open: false,
            children: [
                {
                    parent: '系统设置',
                    name: '来源管理',
                    path: '/main/setting/source',
                    activePath: '/main/setting/source'
                },
                {
                    parent: '系统设置',
                    name: '健康卡',
                    path: '/main/setting/card',
                    activePath: '/main/setting/card'
                },
            ]
        },
    ],
};
/**
 * @description 根据环境配置api
 */
const option = (): any => {
    let dsObj = {};
    if (process.env.NODE_ENV === "development") {
        window.API_ROOT = "https://fqxk.i-tcm.cn/";
        document.title = "宜心健康客户管理平台（管理端）";
        dsObj = {
            项目名称: "宜心健康客户管理平台（管理端）",
            登录页名称1: "宜心健康客户管理平台（管理端）",
            登录页名称2: "",
            logo: '/common/fqxk.png',
            小程序名称: "番茄心康",
        };
    } else if (process.env.VUE_APP_ENV === "test") {
        window.API_ROOT = "https://fqxk-test.i-tcm.cn/";
        document.title = "宜心健康客户管理平台（管理端）";
        dsObj = {
            项目名称: "宜心健康客户管理平台（管理端）",
            登录页名称1: "宜心健康客户管理平台（管理端）",
            登录页名称2: "",
            logo: '/common/fqxk.png',
            小程序名称: "番茄心康",
        };
    } else if (process.env.VUE_APP_ENV === "validate") {
        window.API_ROOT = "https://fqxk-validate.i-tcm.cn/";
        document.title = "宜心健康客户管理平台（管理端）";
        dsObj = {
            项目名称: "宜心健康客户管理平台（管理端）",
            登录页名称1: "宜心健康客户管理平台（管理端）",
            登录页名称2: "",
            logo: '/common/fqxk.png',
            小程序名称: "番茄心康",
        };
    } else if (process.env.VUE_APP_ENV === "production") {
        window.API_ROOT = "https://fqxk.i-tcm.cn/";
        document.title = "宜心健康客户管理平台（管理端）";
        dsObj = {
            项目名称: "宜心健康客户管理平台（管理端）",
            登录页名称1: "宜心健康客户管理平台（管理端）",
            登录页名称2: "",
            logo: '/common/fqxk.png',
            小程序名称: "番茄心康",
        };
    }
    return dsObj
};
export { option, partConfiguration };
